import { render, staticRenderFns } from "./SchoolDay.vue?vue&type=template&id=72090d39&"
import script from "./SchoolDay.vue?vue&type=script&lang=js&"
export * from "./SchoolDay.vue?vue&type=script&lang=js&"
import style0 from "./SchoolDay.vue?vue&type=style&index=0&id=72090d39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports